
export default function AboutAward() {
  return (
    <>
    <section className="aboutpage-award">
        <div className="container">
            <div className="row">  

                <div className="col-lg-12">
                    <h4 className="heading center-heading">Award-Winning Excellence</h4>
                </div>

                <div className="col-lg-6 col-6 col-sm-6">
                    <div className="aboutaward-image awardimage-left">
                        <div>
                            <img src="/image/award-1.webp" className="img-responsive" alt="Award" loading="lazy"/>
                        </div>
                        <span>Elite Design Award 2024</span>
                        <p>Recognized for creating innovative, functional spaces with exceptional aesthetic balance.</p>
                    </div>
                </div>

                <div className="col-lg-6 col-6 col-sm-6">
                    <div className="aboutaward-image awardimage-right">
                        <div>
                            <img src="/image/award-2.webp" className="img-responsive" alt="Award" loading="lazy"/>
                        </div>
                        <span>Modern Interior Excellence</span>
                        <p>Awarded for delivering outstanding contemporary designs that elevate everyday living.</p>
                    </div>
                </div>

                {/* <div className="col-lg-9">
                    <div className="aboutaward-box">
                        <div>
                            <p><span>1.</span> Archdaily Interior Excellence</p>
                            <p>Best Interior Design - Luxury Homes</p>
                            <p>2021</p>
                        </div>

                        <div>
                            <p><span>2.</span> Global Design Forum</p>
                            <p>Creative Interiors - Workplace Design</p>
                            <p>2022</p>
                        </div>

                        <div>
                            <p><span>3.</span> India Design Awards</p>
                            <p>Best Modern Living Room Concept</p>
                            <p>2022</p>
                        </div>

                        <div>
                            <p><span>4.</span> Elle Decor Honours</p>
                            <p>Innovation In Contemporary Interiors</p>
                            <p>2022</p>
                        </div>

                        <div>
                            <p><span>5.</span> Architecture & Interiors Review</p>
                            <p>Interior Design Studio Of The Year</p>
                            <p>2023</p>
                        </div>

                        <div>
                            <p><span>6.</span> Asia-pacific Interior Awards</p>
                            <p>Best Bespoke Interior Design</p>
                            <p>2024</p>  
                        </div>     
                    </div>
                </div> */}

            </div>
        </div>
    </section>
    </>
  )
}
